// Filename - components/SubMenu.js

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import * as RiIcons from "react-icons/ri";
const isDevMode = process.env.REACT_APP_MODE?.toLowerCase() === 'dev';
const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 16px;

   &:hover {
    background: ${isDevMode ? '#042b0a' : '#252831'};
    border-left: 4px solid ${isDevMode ? 'white' : 'green'};
    cursor: pointer;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  background: #252831;
  height: 60px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px;

  &:hover {
    background: green;
    cursor: pointer;
  }
`;

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  const iconClosed = <RiIcons.RiArrowDownSFill />;
  const iconOpened = <RiIcons.RiArrowUpSFill />;
  let itemChild = item.child;
  let itemUrl = "#";
  if (item.uri) {
    itemUrl = "/admin" + item.uri;
  }
  return (
    <>
      <SidebarLink to={itemUrl} onClick={itemChild.length > 0 && showSubnav}>
        <div>
          <FontAwesomeIcon icon={item.icon} />
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {itemChild.length > 0 && subnav
            ? iconOpened
            : itemChild.length > 0
              ? iconClosed
              : null}
        </div>
      </SidebarLink>
      {subnav > 0 &&
        itemChild.map((item, index) => {
          let itemUrl = "/admin" + item.uri;
          return (
            <DropdownLink to={itemUrl} key={index}>
              <FontAwesomeIcon icon={item.icon} />
              <SidebarLabel>{item.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};

export default SubMenu;
